import * as React from 'react';
import CheckmateApiClient from '../../services/apiClient';
import { DisplayMessages } from '../../utilities/DisplayMessages';
import { IRecoverAccount } from '../../interfaces/IAccount';
import { IValidation } from '../../interfaces/IError';
import { LocalRoutes } from '../../utilities/LocalRoutes';
import { Modal } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import ValidateUtils from '../../shared/validations';
import { showSuccessToast } from '../../shared/ToastUtils';

const _apiClient = new CheckmateApiClient();

interface IRecoverAccountState {
    redirect: boolean;
    redirectTo: string;
    recoverAccount: IRecoverAccount;
    validation: IValidation;
}

export default class RecoverAccount extends React.Component<any, IRecoverAccountState> {
    constructor(props: any) {
        super(props);

        this.state = {
            redirect: false,
            redirectTo: LocalRoutes.Login,
            recoverAccount: {},
            validation: {},
        };
    }

    changeValue = (
        event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>
    ) => {
        const value = event.target.value;

        this.setState({
            recoverAccount: { email: value },
            validation: {},
        });
    };

    handleClose = () => {
        this.setState({ redirect: true });
    };

    handleSuccessMessageClose = () => {
        this.setState({
            redirect: true,
            redirectTo: '/',
        });
    };

    handleSendRecoveryEmail = async () => {
        const response = await _apiClient.recoverAccount(this.state.recoverAccount);
        if (response.errorMessage) {
            this.setState({
                validation: ValidateUtils.parseErrors(response.errors, response.errorMessage),
            });
        } else {
            showSuccessToast(<span>{DisplayMessages.RecoverAccountEmailSent}</span>);
            // call handleSuccessMessageClose after 10 seconds (10000 ms)
            setTimeout(() => {
                this.handleSuccessMessageClose();
            }, 10000);
        }
    };

    render() {
        if (this.state.redirect) {
            return <Navigate to={this.state.redirectTo} />;
        }
        return (
            <Modal
                centered
                show={true}
                dialogClassName="recover-account-dialog centered-modal"
                onHide={this.handleClose}
                backdrop={false}
            >
                <Modal.Header>
                    <Modal.Title>Recover Account</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{DisplayMessages.RecoverAccountSubtitle}</p>
                    <div>
                        <span className="text-danger">{this.state.validation.model}</span>
                        <div className="form-group">
                            <label className="control-label" htmlFor="email">
                                Email*
                            </label>
                            <input
                                className="form-control"
                                type="text"
                                name="email"
                                value={this.state.recoverAccount.email || ''}
                                onChange={this.changeValue}
                            />
                            <span className="text-danger">{this.state.validation.email}</span>
                        </div>
                    </div>
                    <div className="recover-account-btn-div">
                        <button
                            className="btn btn-black full-width mt-3"
                            onClick={this.handleSendRecoveryEmail}
                        >
                            Send Account Recovery Email
                        </button>
                        <button
                            className="btn btn-default float-end mt-2 me-0"
                            onClick={this.handleClose}
                        >
                            Cancel
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}
